import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import { TooltipGlow777Box } from "./tooltip-glow.777";
import { TooltipGlowDefaultBox } from "./tooltip-glow.default";

export const TooltipGlowBox = styledByTheme(TooltipGlowDefaultBox).forCasino777(TooltipGlow777Box).apply();